import type { BillingProductType } from '@portal/rocket-api-client';

export enum PlanTypeParam {
  Managed = 'managed-plans',
  Agency = 'agency-plans',
  Enterprise = 'enterprise-plans',
}

export const PLAN_PARAM_TO_PRODUCT: Record<PlanTypeParam, BillingProductType> = {
  [PlanTypeParam.Managed]: 'Managed',
  [PlanTypeParam.Agency]: 'Agency',
  [PlanTypeParam.Enterprise]: 'Enterprise',
};
